// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"fa30c321","988":"94b28f74"}[chunkId] + ".css";
};